import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { NgMatModule } from '@shared/modules/ngmat.module';
import { LayoutModule } from 'src/app/_layout/layout.module';
import { CheckComponent } from './components/pages/check/check.component';
import { OverlayComponent } from './components/overlay/overlay.component';
import { FaceCheckComponent } from './face-check.component';
import { MediaComponent } from './components/pages/media/media.component';
import { MediaErrorComponent } from './components/pages/media-error/media-error.component';
import { OrientationErrorComponent } from './components/pages/orientation-error/orientation-error.component';
import { I18nModule } from '@shared/i18n/i18n.module';
import { RouterModule } from '@angular/router';
import { DomModule } from '@shared/dom';
import { MediaRecorderModule } from '../media-recorder/media-recorder.module';
import { VideoComponent } from './components/video/video.component';
import { UploadingProcessorComponent } from 'src/app/_bio-check/face-check/uploading-processor/uploading-processor.component';
import { MatIconModule } from '@angular/material/icon';
import { FaceRecordButtonComponent } from './face-record-button/face-record-button.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NgMatModule,
    LayoutModule,
    I18nModule,
    RouterModule,
    DomModule,
    MediaRecorderModule,
    MatIconModule
],
  declarations: [
    CheckComponent,
    FaceCheckComponent,
    MediaComponent,
    MediaComponent,
    MediaErrorComponent,
    OverlayComponent,
    OrientationErrorComponent,
    UploadingProcessorComponent,
    VideoComponent,
    FaceRecordButtonComponent,
  ],
  exports: [
    FaceCheckComponent,
  ],
})
export class FaceCheckModule { }
